module.exports = __webpack_public_path__ + "static/media/good-2.ce99a33d.svg";